export class OrderDataModel {
  consecutive: number = 0;
  dateOrder: Date = new Date;
  sellerCodeName: string = "";
  observation: string | null = null;
  observationCommercial: string | null = null;
  observationRemission: string | null = null;
}
